import { Spin } from "antd";
import React from "react";
import useDetailModel from "../viewmodel/DetailModel";
import OrderDkttbDetail from "./model/OrderDkttbDetail";
import TransactionDetail from "./model/TransactionDetail";
import { LoadingOutlined } from "@ant-design/icons";

const antIcon = (
  <LoadingOutlined
    style={{
      fontSize: 42,
      color: "var(--mk-p-color)",
    }}
    spin
  />
);

const DetailPage: React.FC = () => {
  const { loading, detail, type } = useDetailModel();

  const renderDetail = () => {
    if (type === "orderDkttb") {
      return <OrderDkttbDetail info={detail} />;
    }
    if (type === "transaction") {
      return <TransactionDetail info={detail} />;
    }
    return null;
  };

  return (
    <div className="p-[20px] min-h-screen">
      {loading ? (
        <div className="flex items-center justify-center min-h-screen">
          <Spin
            spinning={loading}
            indicator={antIcon}
            tip={
              <span style={{ color: "var(--mk-p-color)" }}>Đang tải...</span>
            }
            size="large"
          />
        </div>
      ) : (
        renderDetail()
      )}
    </div>
  );
};

export default DetailPage;
